<template>
  <table :class="classes">
    <slot />
  </table>
</template>
<script lang="ts" setup>
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    bordered?: boolean;
    rounded?: boolean;
    flush?: boolean;
    size?: 'sm' | 'md';
  }>(),
  {
    size: 'md',
    rounded: false,
    flush: false,
    bordered: true,
  },
);
const classes = computed(() => {
  return {
    'table w-full group mb-0': true,
    'border-0': !props.bordered,
    flush: !props.flush,
    'border-collapse border-slate-500': props.bordered,
    border: !props.bordered && !props.flush,
    'text-sm table-sm': props.size === 'sm',
    'rounded table-rounded': props.rounded,
  };
});
</script>
